export default function Company() {
  return (
    <section id="company" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            会社情報
          </h2>
          <p className="text-lg text-gray-600">
            株式会社プラスゼットについて
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">企業理念</h3>
            <div className="space-y-6">
              <p className="text-gray-700 leading-relaxed">
                製薬企業における安全性システムの運用は、近年ますます高度化・複雑化しています。グローバル規制への対応、各国当局への迅速な安全性報告、データ管理の厳格化などにより、安全性情報管理の重要性はこれまで以上に高まっています。その一方で、安全性システムの導入や運用には専門的な知識が求められ、適切なコンフィグレーション設計や業務に即した運用構築、ユーザー教育などが大きな課題となっています。
              </p>
              <p className="text-gray-700 leading-relaxed">
                当社は、安全性システムの専門知識、国内外の規制理解、そして実際の安全性業務運用に関する豊富な経験を基盤に、製薬企業の安全性システム導入および運用を総合的に支援します。正しいコンフィグレーション設計、実践的なユーザートレーニング、運用に即したシステム活用を通じて、より迅速で確実なシステム導入と安定した運用体制の構築を実現します。
              </p>
              <p className="text-gray-700 leading-relaxed">
                さらに、当社は単なるシステム導入支援にとどまらず、安全性業務の効率化や品質向上を目指したソリューションを提供しています。安全性システム、規制、そして業務運用の三つの視点を統合し、製薬企業にとって最適な安全性情報管理体制を構築することで、より正確で迅速な副作用情報の管理・報告を可能にします。
              </p>
              <p className="text-gray-700 leading-relaxed">
                私たちは、安全性情報が適切に管理され、必要な情報が迅速に共有される環境を整えることで、医薬品の安全性確保に貢献し、患者様が安心して医薬品を使用できる社会の実現を目指してまいります。
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-12 shadow-lg border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">会社概要</h3>
            <dl className="space-y-6">
              <div className="border-b border-gray-200 pb-4">
                <dt className="text-sm font-bold text-gray-700 mb-2">会社名</dt>
                <dd className="text-gray-900">株式会社プラスゼット</dd>
              </div>
              <div className="border-b border-gray-200 pb-4">
                <dt className="text-sm font-bold text-gray-700 mb-2">代表取締役</dt>
                <dd className="text-gray-900">三上　博己</dd>
              </div>
              <div className="border-b border-gray-200 pb-4">
                <dt className="text-sm font-bold text-gray-700 mb-2">設立</dt>
                <dd className="text-gray-900">2014年6月</dd>
              </div>
              <div className="border-b border-gray-200 pb-4">
                <dt className="text-sm font-bold text-gray-700 mb-2">従業員数</dt>
                <dd className="text-gray-900">3名（派遣を含む）</dd>
              </div>
              <div className="border-b border-gray-200 pb-4">
                <dt className="text-sm font-bold text-gray-700 mb-2">所在地</dt>
                <dd className="text-gray-900">
                  〒160-0015<br />
                  東京都新宿区大京町31－4 ブリリアイスト千駄ヶ谷
                </dd>
              </div>
              <div>
                <dt className="text-sm font-bold text-gray-700 mb-2">事業内容</dt>
                <dd className="text-gray-900 leading-relaxed">
                  ・製薬会社およびその関連会社並びに医療施設向けのコンサルタント業務<br />
                  ・治験、安全性、製造販売後等に関するコンサルタント業務<br />
                  ・安全性システムの導入支援、コンサルタント業務<br />
                  ・安全性システムに関連する周辺システムの立案、開発支援、販売<br />
                  ・安全性システム、業務おける資料、バリデーション等の作成、支援<br />
                  ・安全性システムのトレーニング等
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}